export const getDisconnectConfirmAlertMessage = (integrationName) =>
  `Are you sure you want to disconnect from ${integrationName}?`;
